/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import DTable from "../components/TicketTables/Agent-Golbal-TktsTable"

import icons from "variables/icons";

class AllTickets extends React.Component {
  


  render() {

let params = this.props.match.params.all
    return (

      
      <>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col md={12}>
              <Card>

                <CardBody className="all-icons">

                {params !== ":all" ?

                  <DTable targetstate={params} /> :<DTable /> }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default AllTickets;
